// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this to remove top padding when navigation is removed */
/* #wrapper.sidebarClosed #page-wrapper {
  padding-top: 15px; /* Same as left/right padding, removes the 52px top padding */
/* } */ */

.top-navs-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.single-nav-container {
    margin: 15px;
    border: 1px solid black;
    padding: 10px;
}

.nav-hor-list {
    width: 100%;
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    padding: 5px;
}

/* .add-modal-container-nav {
    width: 80%;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1%;
    border-radius: 1%;
  } */

.nav-item-inp {
    margin: 8px;
    font-size: 20px;
    padding: 2px;
}

.edit-but {
    background: orange;
    margin: 7px;
}

.del-but {
    color: rgb(117, 4, 4);
    margin: 7px;
}

.create-but {
    margin: 10px;
}

.dest-data-container-nav {
    width: 60%;
  }

.input-params-conatiner {
    width: 100%;
    height: 30%;
    overflow: scroll;
}

.dest-data-pre {
    width: 60%;
}

.dest-data-json {
    margin : 30px 0;
    width: 500px;
    overflow-x: scroll;
}

.collection-search-input {
    width: 240px;
    margin-right: 12px;
}

.select-collection {
    height: 25px;
}`, "",{"version":3,"sources":["webpack://./client/components/dashboard/TopNavAdmin/TopNavAdmin.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;kFACkF;AAClF,MAAM,EAAE;;;IAGJ,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;;;;;;;KAQK;;AAEL;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;EACZ;;AAEF;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/* Add this to remove top padding when navigation is removed */\n/* #wrapper.sidebarClosed #page-wrapper {\n  padding-top: 15px; /* Same as left/right padding, removes the 52px top padding */\n/* } */ */\n\n.top-navs-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.single-nav-container {\n    margin: 15px;\n    border: 1px solid black;\n    padding: 10px;\n}\n\n.nav-hor-list {\n    width: 100%;\n    overflow-x: scroll;\n    display: flex;\n    flex-direction: row;\n    padding: 5px;\n}\n\n/* .add-modal-container-nav {\n    width: 80%;\n    background: white;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 1%;\n    border-radius: 1%;\n  } */\n\n.nav-item-inp {\n    margin: 8px;\n    font-size: 20px;\n    padding: 2px;\n}\n\n.edit-but {\n    background: orange;\n    margin: 7px;\n}\n\n.del-but {\n    color: rgb(117, 4, 4);\n    margin: 7px;\n}\n\n.create-but {\n    margin: 10px;\n}\n\n.dest-data-container-nav {\n    width: 60%;\n  }\n\n.input-params-conatiner {\n    width: 100%;\n    height: 30%;\n    overflow: scroll;\n}\n\n.dest-data-pre {\n    width: 60%;\n}\n\n.dest-data-json {\n    margin : 30px 0;\n    width: 500px;\n    overflow-x: scroll;\n}\n\n.collection-search-input {\n    width: 240px;\n    margin-right: 12px;\n}\n\n.select-collection {\n    height: 25px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
